import React from 'react';

import Card from 'crm/elements/common/Card';
import Row, { TableDetailsBody } from 'crm/elements/common/TableDetailsRow';

function PostbackDetails({ postback }) {
    const { id, url, slug, method, action } = postback;

    return (
        <Card title="Postback details">
            <TableDetailsBody>
                <Row label="ID">{id}</Row>
                <Row label="Url">{url}</Row>
                <Row label="Slug">{slug}</Row>
                <Row label="Method">{method}</Row>
                <Row label="Action">{action}</Row>
            </TableDetailsBody>
        </Card>
    );
}

export default PostbackDetails;
